import React from 'react';
import styled from 'styled-components';
import { CheckboxGroup } from 'components/core/checkbox-group';

import { CategoryOption } from './types';

type SubcategoriesListMultiSelectProps = {
  subcategories: CategoryOption[];
  selectedSubcategories: string[];
  handleClickSubcategory: (subcategoryValue: string) => void;
};

export function SubcategoriesListMultiSelect(props: SubcategoriesListMultiSelectProps): JSX.Element {
  const { subcategories, selectedSubcategories, handleClickSubcategory } = props;

  const options = subcategories.map((subcategory: CategoryOption) => ({
    key: subcategory.key,
    value: subcategory.value,
    label: subcategory.label,
  }));

  return (
    <SubcategoriesContainer>
      <CheckboxGroup options={options} selectedOptions={selectedSubcategories} onSelect={handleClickSubcategory} />
    </SubcategoriesContainer>
  );
}

const SubcategoriesContainer = styled.div`
  > ul {
    margin-top: 0;
  }
`;
